/** Lossy minifaction of location entities for payload savings
 *
 * This is used by the id-dispensers. The id-dispensers need to figure
 * out location relationships and for that they load all existing locations.
 * To reduce the payload and the parse time, we strip the locations of
 * unneeded data and remove the field names.
 * The location object is transformed into nested arrays that only
 * store the needed values. The unminification then transforms
 * the arrays back into a location object.
 */
const Indices = {
  id: 0,
  level: 1,
  relationships: 2,
  relationshipRules: 3,
  programs: 4
}
const NumIndices = Object.keys(Indices).length

function minifyPrograms (programs) {
  const minPrograms = []
  for (const { id: programId, services } of programs) {
    const minProgramId = programId.split(':').pop()
    const minServices = []
    for (const { id: serviceId, funderId, routeId } of services) {
      const minServiceId = serviceId.split(':').pop()
      const minFunderId = funderId != null ? funderId.split(':').pop() : null
      const minRouteId = routeId != null ? routeId.split(':').pop() : null
      minServices.push([minServiceId, minFunderId, minRouteId])
    }
    minPrograms.push([minProgramId, minServices])
  }
  return minPrograms
}

function unminifyPrograms (minPrograms) {
  const programs = []
  for (const [minProgramId, minServices] of minPrograms) {
    const services = []
    for (const [minServiceId, minFunderId, minRouteId] of minServices) {
      services.push({
        id: `program:${minProgramId}:service:${minServiceId}`,
        funderId: minFunderId ? `funder:${minFunderId}` : null,
        routeId: minRouteId ? `route:${minRouteId}` : null
      })
    }
    programs.push({
      id: `program:${minProgramId}`,
      services
    })
  }
  return programs
}

function minifyLocations (allLocations) {
  const ms = new Array(allLocations.length)
  for (const [i, l] of allLocations.entries()) {
    const m = new Array(NumIndices)
    m[Indices.id] = l._id
    m[Indices.level] = l.level
    m[Indices.relationships] = Object.entries(l.relationships || {})
    m[Indices.relationshipRules] = Object.entries(l.relationshipRules || {})
    m[Indices.programs] = minifyPrograms(l.programs)
    ms[i] = m
  }
  return ms
}

function unminifyLocations (minLocations) {
  const locations = new Array(minLocations.length)
  for (const [i, m] of minLocations.entries()) {
    const id = m[Indices.id]
    const location = {}
    const idParts = id.split(':')
    let geoParts = []
    if (!idParts[0] !== 'country') {
      geoParts.push('country', 'ng')
    }
    for (let i = 0; i < idParts.length; i += 2) {
      const key = idParts[i]
      const val = idParts[i + 1]
      location[key] = val
      if (key !== 'name' && key !== 'sdp') {
        geoParts.push(key, val)
      }
    }
    location.country = location.country || 'ng'
    location.id = geoParts.join(':')
    locations[i] = {
      _id: id,
      location,
      level: m[Indices.level],
      relationships: Object.fromEntries(m[Indices.relationships]),
      relationshipRules: Object.fromEntries(m[Indices.relationshipRules]),
      programs: unminifyPrograms(m[Indices.programs])
    }
  }
  return locations
}

module.exports = {
  minifyLocations,
  unminifyLocations
}
